import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import TimerButton from "@material-ui/icons/Timer";
import { Creators as BuscaClienteActions } from "../../store/ducks/buscaCliente";
import AtendimentoForm from "../Forms/Atendimento";
import moment from "moment";
import { withRouter } from "react-router";

class Atendimento extends Component {
  state = {
    hours: "",
    minutes: "",
    seconds: ""
  };
  componentDidMount() {
    let self = this;
    setInterval(function() {
      let duration = moment.duration(
        moment().diff(moment(self.props.atendimento.atendimento.started_at))
      );
      self.setState({
        hours: duration.get("hours"),
        minutes: duration.get("minutes"),
        seconds: duration.get("seconds")
      });
    }, 1000);
  }

  componentDidUpdate() {
    if (
      !!this.props.atendimento.atendimento.id &&
      this.props.atendimento.atendimento.customer
    ) {
      document
        .getElementById("novo-atendimento")
        .addEventListener("mouseenter", function() {
          document.getElementById("body-atendimento").style.display = "block";
        });
      document
        .getElementById("novo-atendimento")
        .addEventListener("mouseleave", function() {
          document.getElementById("body-atendimento").style.display = "none";
        });
    }
  }
  render() {
    return !!this.props.atendimento.atendimento.id &&
      this.props.atendimento.atendimento.customer ? (
      <div className="novo-atendimento" id="novo-atendimento">
        <div className="head-atendimento">
          <div className="foto-cliente">
            {this.props.atendimento.atendimento.customer.photo && (
              <img
                alt={`Foto ${this.props.atendimento.atendimento.customer.name}`}
                src={this.props.atendimento.atendimento.customer.photo}
              />
            )}
          </div>
          <div className="messages-columns">
            <span className="customer-name">
              {this.props.atendimento.atendimento.customer.name}
            </span>
            <div className="messages-clock">
              <span className="tag-atendimento">Em Atendimento</span>
              <div className="timer">
                <TimerButton />
                <small>
                  {this.state.hours < 10 && "0"}
                  {this.state.hours}:
                </small>
                <small>
                  {this.state.minutes < 10 && "0"}
                  {this.state.minutes}:
                </small>
                <small>
                  {this.state.seconds < 10 && "0"}
                  {this.state.seconds}
                </small>
              </div>
            </div>
          </div>
        </div>
        <AtendimentoForm />
      </div>
    ) : null;
  }
}

const mapStateToProps = state => ({
  atendimento: state.atendimento
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      ...BuscaClienteActions
    },
    dispatch
  );

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Atendimento)
);



// WEBPACK FOOTER //
// ./src/components/Atendimento/index.js